import React, { useEffect, useState } from "react";
import { Document, Page, pdfjs } from "react-pdf";

pdfjs.GlobalWorkerOptions.workerSrc = `https://cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;

const PDFViewerFromSignedURL = ({ signedUrl }) => {
    const [pdfData, setPdfData] = useState(null);
    const [numPages, setNumPages] = useState(null);
    const [error, setError] = useState(null);
    const pdfWidth = window.innerWidth * 0.9;

    useEffect(() => {
        const loadPdf = async () => {
            try {
                const response = await fetch(signedUrl, {
                    method: "GET",
                    mode: "cors",
                });

                if (!response.ok) {
                    throw new Error(`HTTP error: ${response.status}`);
                }

                const blob = await response.blob();

                setPdfData(blob);
            } catch (err) {
                setError("Unable to load PDF. Please check CORS or URL.");
            }
        };

        loadPdf();
    }, [signedUrl]);

    const onDocumentLoadSuccess = ({ numPages }) => {
        setNumPages(numPages);
    };

    return (
        <div  style={{ overflow: "scroll", height: "78vh", scale: "0.9" }} className="default-invoice">
            {error && <div style={{ color: "red" }}>{error}</div>}

            {pdfData && (
                <Document
                    file={pdfData}
                    onLoadSuccess={onDocumentLoadSuccess}
                    onLoadError={(err) => {
                        setError("Failed to render PDF.");
                    }}
                >
                    {Array.from({ length: numPages || 0 }, (_, index) => (
                        <Page
                            key={`page_${index + 1}`}
                            pageNumber={index + 1}
                            renderTextLayer={false}
                            renderAnnotationLayer={false}
                            width={pdfWidth}
                        />
                    ))}
                </Document>
            )}
        </div>
    );
};

export default PDFViewerFromSignedURL;